<template>
  <div id="promotion">
    <div class="top-section">
      <div class="title-wapper">我的用户</div>
      <div class="total-box">
        总计用户数：
        <span class="amount-number">80</span>人
      </div>
    </div>
    <div class="bottom-section">
      <div class="cash-wapper">
        <div class="cash-item" v-for="(item, i) in 2" :key='i'>
          <van-image width="50px" height="50px" :src="userImg"/>
          <div class="user-detail">
            <div class="user-name">wanhezhongzhi（189****5781）</div>
            <div class="time">
              <span>注册时间：</span>
              <span>2023-08-09  13:09:45</span>
            </div>
          </div>
        </div>
      </div>
      <div class="pagination-section">
        <span>共20页，当前第</span>
        <van-pagination 
          v-model="currentPage"
          :total-items="50" 
          :show-page-size="1">
          <template #prev-text>
            <van-icon :class="currentDirection == 1? 'chosed-direction': ''" name="arrow-left"
            @click="changeDirection(1)" />
          </template>
          <template #next-text>
            <van-icon :class="currentDirection == 2? 'chosed-direction': ''" name="arrow"
            @click="changeDirection(2)" />
          </template>
          <template #page="{ text }">{{ text }}</template>
        </van-pagination>
        <span>页</span>
      </div>
      
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      userImg: require("../../../assets/index/tgm.png"),
      currentPage: 1,
      currentDirection: 2
    }
  },
  created () {
    //12
  },
  // 过滤电话号码
  filters: {
    mobileFilter(val) {
      let reg = /^(.{3}).*(.{4})$/;
      if (val) {
        return val.replace(reg, "$1****$2");
      }
    },
  },
  methods: {
    changeDirection(e) {
      this.currentDirection = e
      console.log('kll', e)
    }
  }
}
</script>


<style lang="less" scoped>
@import "~@/styles/variable.less";

#promotion {
  font-size: 14px;
  height: 400px;
  .top-section {
    background: linear-gradient(to right, #47A4FF, #396CFF);
    height: 100px;
    color: white;
    .title-wapper {
      text-align: center;
      padding: 15px 0;
      font-size: 16px;
    }
    .total-box {
      margin-left: 10px;
    }
  }
  .bottom-section {
    background: #F5F6F7;
    height: 300px;
    .cash-wapper {
      padding: 15px 15px;
      .cash-item {
        display: flex;
        align-items: center;
        background: #FFFFFF;
        padding: 5px 8px;
        margin-bottom: 10px;
        border-radius: 5px;
        /deep/.van-image {
          margin-right: 10px;
        }
        .user-detail {
          .user-name {
            font-size: 16px;
            color: #000;
            margin-bottom: 3px;
          }
          .time {
            color: #999999;
          }
        }
      } 
    }
  }
  .pagination-section {
    display: flex;
    align-items: center;
    position: fixed;
    bottom: 20px;
    left:20%;
    .chosed-direction {
      background-color: #2878FF;
      padding: 10px;
    }
    /deep/.van-pagination__item--active {
      background-color: #FFFFFF;
    }
    /deep/.van-pagination__item--disabled {
      background-color: #E8E8E8;
    }
  }
}
</style>